import styled from "@emotion/styled";
import { neutralDark20 } from "../../../../constants/colors";

export const DatePickerTextInputPlaceholderVisible = styled("span")`
    color: ${neutralDark20};
`;
